import { removeNode } from './utils'
import './confirm.scss'
function Confirm () {
  return {
    name: 'edj-component-confirm',
    data () {
      return {
        message: '',
        cancelText: '',
        confirmText: '',
        cancelCallback: () => {},
        confirmCallback: () => {}
      }
    },
    methods: {
      onConfirmClick () {
        this.confirmCallback()
      },
      onCancelClick () {
        this.cancelCallback()
      },
      close () {
        this.$destroy()
        removeNode(this.$el)
      }
    },
    render (h) {
      const data = Object.assign({}, this.props, this)
      console.log(this)
      return (
        <div class="confirm-box">
          <div class="confirm">
            <div class="confirm-msg">
              {
                typeof this.$scopedSlots.message !== 'undefined'
                  ? this.$scopedSlots.message()
                  : <p class="msg" domPropsInnerHTML={data.message}></p>
              }
              {
                typeof this.$scopedSlots.default !== 'undefined'
                  ? this.$scopedSlots.default()
                  : null
              }
            </div>
            <div class="btn-container">
              {
                typeof data.cancelText !== 'undefined'
                  ? (<button onClick={data.cancelCallback}>
                    {data.cancelText}
                  </button>)
                  : null
              }
              {
                typeof data.confirmText !== 'undefined'
                  ? (<button
                    onClick={data.confirmCallback}
                    class={`${typeof data.cancelText !== 'undefined' ? 'borderLeft' : ''}`}
                  >
                    {data.confirmText}</button>)
                  : null
              }
            </div>
          </div>
        </div>
      )
    }
  }
}

export default Confirm



// WEBPACK FOOTER //
// ./src/components/confirm/confirm.jsx